import { isNegativeNumber } from '../../utils/format';
import './MetricCard.css';

const ICON_IMAGES = {
  chart: '/images/floating.svg',
  dollar: '/images/close.svg',
  percent: '/images/commission.svg',
  swap: '/images/swap.svg',
  deposit: '/images/deposit.svg',
  withdrawal: '/images/withdrawal.svg',
  trading: '/images/activetrading.svg',
};

const ICONS = {
  orders: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="6" y="5" width="12" height="15" rx="2" stroke="currentColor" strokeWidth="2" />
      <path
        d="M9 5V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M9 11h6M9 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
};

function iconFromLabel(label = '') {
  const l = label.toLowerCase();
  if (l.includes('floating')) return 'chart';
  if (
    l.includes('closed') ||
    /^close\b/.test(l) ||
    (l.includes('profit') && !l.includes('floating'))
  ) {
    return 'dollar';
  }
  if (l.includes('commission')) return 'percent';
  if (l.includes('swap')) return 'swap';
  if (l.includes('deposit')) return 'deposit';
  if (l.includes('withdrawal')) return 'withdrawal';
  if (l.includes('active') || (l.includes('trading') && !l.includes('closed'))) return 'trading';
  if (l.includes('order') || l.includes('trade')) return 'orders';
  return 'chart';
}

function isNegativeDisplay(numericValue, displayValue) {
  if (numericValue != null && Number.isFinite(Number(numericValue))) {
    return isNegativeNumber(numericValue);
  }
  return typeof displayValue === 'string' && displayValue.trim().startsWith('-');
}

export default function MetricCard({
  label,
  value,
  sub,
  large = false,
  numericValue,
  icon,
}) {
  const iconKey = icon || iconFromLabel(label);
  const displayValue = value ?? '—';
  const neg = isNegativeDisplay(numericValue, displayValue);
  const iconImage = ICON_IMAGES[iconKey];

  return (
    <div className={`metric-card${large ? ' metric-card--large' : ''}`}>
      <div
        className={`metric-card__icon metric-card__icon--${iconKey}${
          iconImage ? ' metric-card__icon--asset' : ''
        }`}
      >
        {iconImage ? (
          <img src={iconImage} alt="" className="metric-card__icon-img" aria-hidden="true" />
        ) : (
          ICONS[iconKey] || null
        )}
      </div>
      <div className="metric-card__body">
        <span className="metric-card__label">{label}</span>
        <span className={`metric-card__value${neg ? ' metric-card__value--neg' : ''}`}>
          {displayValue}
        </span>
        <span className="metric-card__sub">{sub || '\u00A0'}</span>
      </div>
    </div>
  );
}
